import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from "@angular/forms/forms";
import { LoginService } from "../login/login.service";
import { HttpErrorResponse } from "@angular/common/http";
import { Router } from "@angular/router";
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService, NgxSpinnerComponent } from 'ngx-spinner';
declare var $: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  @ViewChild('loginForm') loginForm: NgForm;
  @ViewChild('forgetPasswordForm') forgetPasswordForm: NgForm;
  data: any;
  responseData: any;
  constructor(private service: LoginService, private router: Router, private toastr: ToastrService, private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    localStorage.clear();
  }

  onSubmit() {
    if (this.loginForm.valid) {
      this.spinner.show();
      var Requestdata = {
        UserName: this.loginForm.value['userName'],
        PWD: this.loginForm.value['password']
      }
      this.service.Login(Requestdata)
        .subscribe((data1: Response) => {
          this.spinner.hide();
          this.data = data1;
          if (this.data.status == false) {
            this.toastr.error('User name or password is invalid');
          } else {
            localStorage.setItem("token", this.data.Token);
            localStorage.setItem("userName", this.loginForm.value['userName']);
            localStorage.setItem("cd",  ")(*&");
            localStorage.setItem("userID", this.data.UserID);
            localStorage.setItem("hashCode", this.data.HashCode);
            localStorage.setItem("yearID", this.data.YearID);
            localStorage.setItem("yearName", this.data.YearName);
            this.router.navigate(['/dashboard']);
          }
        }, (err: HttpErrorResponse) => {
          localStorage.clear();
          this.spinner.hide();
          this.toastr.error('Something Went Wrong');
          this.router.navigate(['/aciadmin']);
        });
    }
  }
  openpopup(){
    this.forgetPasswordForm.resetForm();
    $('#forgetpassModal').modal('show');
  }
  closeForm(){
    $('#forgetpassModal').modal('hide');
  }
  forgetPassword() {
    var val = this.forgetPasswordForm.value['emailid'];
    var patternMail = "^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$";
    var patternMobile = "[0-9]{10}";
    if (!val.match(patternMail) && !val.match(patternMobile)) {
      this.toastr.error(" Enter proper detail")
      return
    }
    if (this.forgetPasswordForm.valid) {
      this.spinner.show();
      var data = {
        emailID: this.forgetPasswordForm.value['emailid']
      }
      this.service.forgetPassword(data)
        .subscribe((data1: Response) => {
          this.spinner.hide();
          this.responseData = data1;
          if (this.responseData.status == false) {
            this.toastr.error(this.responseData.message);
            return
          } else {
            this.toastr.success(this.responseData.message);
            $('#forgetpassModal').modal('hide');
          }
        }, (err: HttpErrorResponse) => {
          localStorage.clear();
          this.spinner.hide();
          this.toastr.error('Something Went Wrong');
          this.router.navigate(['/aciadmin']);
        });
    }
  }
}
